"use strict";

exports.__esModule = true;
exports.default = void 0;

var renderLine = function renderLine(ctx, node) {
  var _ref = node.props || {},
      x1 = _ref.x1,
      x2 = _ref.x2,
      y1 = _ref.y1,
      y2 = _ref.y2;

  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
};

var _default = renderLine;
exports.default = _default;